import { useMatches } from "react-router-dom";

export default function useParentRoute() {
    const locationMatch = useMatches();
    return locationMatch[locationMatch.length - 2];   
}